import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Project } from '../../../model/api/assets/project';
import { GenericHttpService } from '../generic.http.service';

@Injectable()
export class ProjectHttpService extends GenericHttpService<Project, number> {
    constructor(public http: HttpClient) {
        super(http, '', 'projects');
    }
}
